import { render, staticRenderFns } from "./message-entity-table.vue?vue&type=template&id=c3b1ebb0&scoped=true&"
import script from "./message-entity-table.vue?vue&type=script&lang=ts&"
export * from "./message-entity-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b1ebb0",
  null
  
)

export default component.exports